import { SharedAngular } from '@Client/@types/sharedAngular';
import { ISmartSearchResult } from '@Shared.Angular/@types/core/contracts/queryModel/smartSearch/smartSearchResult';
import angular from 'angular';

export class SmartSearchService {
  public static $inject = ['$http', 'APP_CONFIG'];
  private apiBaseUrl: string;
  public lastSearchTerm = '';
  public lastSearchResults: ISmartSearchResult[] | null = null;

  constructor(
    private $http: angular.IHttpService,
    private APP_CONFIG: SharedAngular.APP_CONFIG
  ) {
    this.apiBaseUrl = APP_CONFIG.apiBaseUrl + 'smartsearch/';
  }

  public getSearchResults(
    userInput: string
  ): angular.IPromise<ISmartSearchResult[]> {
    return this.$http
      .get<ISmartSearchResult[]>(this.apiBaseUrl, {
        params: { query: userInput },
        noSpinner: true
      })
      .then((response) => {
        this.lastSearchTerm = userInput;
        this.lastSearchResults = response.data;
        return response.data;
      });
  }
}

angular
  .module('flowingly.runner.services')
  .service('smartSearchService', SmartSearchService);

export type SmartSearchServiceType = InstanceType<typeof SmartSearchService>;
